export const getPricing = (values, pricings = {}) => {
  if (values.cesu) {
    return pricings?.pricing_with_cesu;
  }
  if (values.urssaf) {
    return pricings?.pricing_with_tax;
  }
  if (pricings?.pricing_without_cesu) {
    return pricings?.pricing_without_cesu;
  }
  return { total: 0 };
};
